type GetItem<T> =
  | ((key: string, defaultValue?: T) => T | undefined)
  | ((key: string, defaultValue: T) => T);

const localStorageSupported =
  typeof window.localStorage !== "undefined" && window.localStorage != null;

export const writeItem = <T>(key: string, item: T) => {
  if (localStorageSupported) {
    localStorage.setItem(key, JSON.stringify(item));
  }
};
export const removeItem = (key: string) => {
  if (localStorageSupported) {
    localStorage.removeItem(key);
  }
};
export const getItem = <T>(key: string, defaultValue?: T): T => {
  if (localStorageSupported) {
    const item = localStorage.getItem(key);
    if (item) {
      return JSON.parse(item) as T;
    }
  }
  return defaultValue as T;
};
export const getAllItems = () => {
  const list = new Array<{ key: string; value: any }>();
  for (let i = 0; i < localStorage.length; i += 1) {
    const keyItem = localStorage.key(i);
    const value = keyItem && localStorage.getItem(keyItem);
    keyItem &&
      value &&
      list.push({
        key: keyItem,
        value: JSON.parse(value) as any,
      });
  }
  return list;
};
export const clearAllItems = () => {
  localStorage.clear();
};
